import { Modal } from "antd";
import { Flex, Skeleton } from "@chakra-ui/react";
import OutlineButton from "ui/components/Button/OutlineButton";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import CardEquipamento from "./components/CardEquipamento";
import ModalManutencaoEquipamento from "./components/ModalManutencaoEquipamento";
import { useRealizacaoManutencao } from "core/features/manutencao/hooks/useRealizacaoManutencao";
import { useState } from "react";
import {
  ManutencaoDto,
  EquipamentoRealizarManutencaoForm,
} from "core/features/manutencao/typings/index";
import { useLoading } from "components/GlobalLoading/index";
import useConcluirManutencao from "core/features/manutencao/hooks/useConcluirManutencao";

interface ModalRealizarManutencaoProps {
  visible: boolean;
  onClose: () => any;
  refetchList?: () => any;
  manutencaoDto: ManutencaoDto | undefined;
}

export default function ModalRealizarManutencao({
  onClose,
  visible,
  manutencaoDto,
  refetchList,
}: ModalRealizarManutencaoProps) {
  const { data, isLoading, refetch } = useRealizacaoManutencao(
    manutencaoDto?.id,
    manutencaoDto?.dataPrevistaInicial
  );
  const { mutate: concluirManutencao, isLoading: isLoadingConcluir } =
    useConcluirManutencao(manutencaoDto?.id!, data?.id!);

  const [equipamentoModalRealizar, setEquipamentoModalRealizar] = useState<
    Partial<EquipamentoRealizarManutencaoForm> | undefined
  >();

  const _equipamentos =
    manutencaoDto?.equipamentos?.map((equipamento) => {
      const equipamentoRealizado = data?.equipamentos?.find(
        (eq) => eq.id === equipamento.id
      );

      return (
        equipamentoRealizado ||
        (equipamento as Partial<EquipamentoRealizarManutencaoForm>)
      );
    }) || [];

  useLoading(isLoading);

  const hasEquipamentosWithoutStatus = _equipamentos.some(
    (equipamento) => !equipamento.statusManutencaoId
  );

  const disableConcluir = hasEquipamentosWithoutStatus || isLoadingConcluir;

  return (
    <>
      <Modal
        destroyOnClose
        width={"600px"}
        onCancel={onClose}
        centered
        title="Realizar manutenção"
        visible={visible}
        footer={
          <Flex justifyContent="end" gap={4} mb={4}>
            <OutlineButton onClick={onClose}>Cancelar</OutlineButton>
            <PrimaryButton
              disabled={disableConcluir}
              isLoading={isLoadingConcluir}
              onClick={() =>
                concluirManutencao(undefined, {
                  onSuccess: () => {
                    refetchList?.();
                    onClose();
                  },
                })
              }
            >
              Concluir manutenção
            </PrimaryButton>
          </Flex>
        }
      >
        <Flex flexDirection="column" gap={4}>
          {isLoading ? (
            <>
              <Skeleton h="60px" rounded={14} />
              <Skeleton h="60px" rounded={14} />
              <Skeleton h="60px" rounded={14} />
            </>
          ) : (
            _equipamentos.map((v) => (
              <CardEquipamento
                equipamentoStatus={v.statusManutencaoId}
                dataManutencao={data?.data}
                onClick={() => setEquipamentoModalRealizar(v)}
                label={v.nome!}
              />
            ))
          )}
        </Flex>
      </Modal>
      <ModalManutencaoEquipamento
        visible={!!equipamentoModalRealizar?.id}
        onClose={() => setEquipamentoModalRealizar(undefined)}
        equipamento={equipamentoModalRealizar}
        manutencaoDto={manutencaoDto}
        refetchList={refetch}
      />
    </>
  );
}
